function Pending() {
  return <div className="flex flex-col h-full">Torneo no encontrado</div>;
}

export const route = {
  index: true,
  path: 'pending',
  element: <Pending />,
};
